import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import HospitalCard from '../components/HospitalCard';
import axios from 'axios';



function HospitalPage() {
  const { locationName } = useParams();
  const [locationHospitals, setLocationHospitals] = useState([]);
const [loading, setLoading] = useState(true);
  // const displayTitle = capitalize(locationName); // No longer needed

  useEffect(() => {
    const cachedData = sessionStorage.getItem('allHospitals');

    if (cachedData) {
      const allHospitals = JSON.parse(cachedData);
      const filtered = allHospitals.filter(h => h.location === locationName);
      setLocationHospitals(filtered);
      setLoading(false); 
    }
    // Fetch ALL hospitals from backend
    axios.get(process.env.REACT_APP_API_BASE_URL+'/hospitals/')
      .then(response => {
        sessionStorage.setItem('allHospitals', JSON.stringify(response.data));
        // Filter by location on the frontend
        const filtered = response.data.filter(
          hospital => hospital.location === locationName
        );
        setLocationHospitals(filtered);
        setLoading(false);
      })
      .catch(error => console.log(error));
  }, [locationName]);
return (
    <div className="container" style={{ minHeight: '60vh' }}>
      {loading && locationHospitals.length === 0 ? (
        <div className="text-center mt-5">
          <div className="spinner-border text-primary" role="status"></div>
          <p>Loading Hospitals...</p>
        </div>
      ) : (
        locationHospitals.length > 0 ? (
          <div>
            {locationHospitals.map((hospital) => (
              <HospitalCard key={hospital._id} hospital={hospital} />
            ))}
          </div>
        ) : (
          <div className="alert alert-warning">
            No hospitals found for this location.
          </div>
        )
      )} 
    
    </div>
  );
}

export default HospitalPage;